import { render, staticRenderFns } from "./id-copy-component.vue?vue&type=template&id=39f18c5e&"
import script from "./id-copy-component.vue?vue&type=script&lang=ts&"
export * from "./id-copy-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports